// extracted by mini-css-extract-plugin
export default {"root":"radio_root__hMHyc","md":"radio_md__AYCqb","lg":"radio_lg__Eg1m9"};